<div class="wrapper" (click)="openModal($event)">
  <app-shared-icon name="share-outline" [size]="14"></app-shared-icon>
  <span class="label">Share</span>
</div>
